<template>
  <generic-config 
    :values="getAccounts"
    displayText="fname"
    :onSaveHandler="onSave"
    :onDeleteHandler="onDelete"
    entityName="Account"
    >
    <template v-slot:entryForm="{selectedItem, onSaveItem, onDeleteItem}">
      <EntryForm 
        :model="dataModel"
        :data="selectedItem"
        :mode="selectedItem ? 'viewEdit' : 'new'"
        @onSave="onSaveItem"
        @onDelete="onDeleteItem"
      />
    </template>
    <template v-slot:itemListing="{onItemSelected, values}">
      <item-list-tree
        :items="values"
        key="uuid"
        text="name"
        parent="parent"
        @onClick="onItemSelected"
      />
    </template>
  </generic-config>
</template>

<script>
import { Account } from '@/model';
import GenericConfig from "@/components/common/GenericConfig";
import EntryForm from "@/components/common/EntryForm";
import ItemListTree from "@/components/common/ItemListTree"


export default {
  components: {
    GenericConfig,
    EntryForm,
    ItemListTree,
  },
  async created() {
    await this.$store.dispatch("getAccounts");
  },
  computed: {
    accounts() {
      const accounts = (this.$store.state.accounts);
      return accounts ? Account.sort(accounts) : [];
    },
    dataModel() {
      return [
        {label: 'Uuid', valueAttr: 'uuid', type: 'text', display: false},
        {label: 'Name', valueAttr: 'name', type: 'text', display: true, required: true},
        {label: 'Full name', valueAttr: 'fname', type: 'text', display: true, 
          computed: true},
        {label: 'Parent', valueAttr: 'parent', type: 'select', display: true, required: true, 
          immutable: true, values: this.getAccounts, text: 'fname'},
      ];
    }
  },
  methods: {
    getAccountObj(acc) {
      return acc ? 
      {
        uuid: acc.uuid,
        name: acc.name,
        fname: acc.fname,
        parent : acc.parent ? this.getAccountObj(acc.parent.obj()) : undefined,
      } : {};
    },
    getAllAccounts() {
      return this.accounts;
    },
    getAccounts(acc) {
      const accList = (!acc || !acc.uuid) ? this.getAllAccounts() : this.getAllAccounts().filter(a => a.uuid !== acc.uuid);
      return accList.map(this.getAccountObj);
    },
    toAccount(valueObject) {
      if (valueObject.parent) {
        valueObject.parent = valueObject.parent.uuid;
      } 
      const account = Account.fromJson(valueObject);
      return account;
    },
    async onSave(valueObject) {
      console.log("[AccountGenericConfig] onSave()", valueObject);
      const account = this.toAccount(valueObject);
      console.log("[AccountGenericConfig] onSave() parsed", account);
      await this.$store.dispatch("saveAccount", account);
    },
    async onDelete([valueObject, replacement]) {
      console.log("[AccountGenericConfig] onDelete()", valueObject, replacement);
      const account = this.toAccount(valueObject);
      const replacementAcc = replacement ? this.toAccount(replacement) : undefined;
      await this.$store.dispatch("deleteAccount", [account, replacementAcc]);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>